export default __webpack_public_path__ + "static/media/10_PME.4c419cdb.webp";